import { useParams } from 'react-router'
import { ParamSlug, Slug } from 'types'

const useSlug = (slug: Slug) => {
    const params = useParams() as ParamSlug
    return params
        ? params[slug]
        : undefined
}

export default useSlug
